import React from "react";
import PublicPage from "@/components/public/PublicPage";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "@/lib/app-links";
import { Apple, Check, Play } from "lucide-react";
import { Link } from "react-router-dom";

const does = [
  "Daily checks",
  "Temperature records",
  "Cleaning checks",
  "Hygiene inspections",
  "Corrective actions",
  "Incident reporting",
  "Task completion",
  "Mobile inspection records",
];

export default function DownloadApp() {
  return (
    <PublicPage
      eyebrow="Mobile App"
      title="Crystal HACCP on iOS and Android"
      intro="The mobile app is where the team records the work. Everything completed on a phone appears in the web dashboard."
    >
      <section className="relative">
        <div className="max-w-6xl mx-auto px-4 py-10 pb-20 grid lg:grid-cols-2 gap-6">
          <div className="app-card p-6">
            <div className="text-white font-semibold mb-4">What you can do in the app</div>
            <ul className="grid sm:grid-cols-2 gap-x-5 gap-y-2">
              {does.map((d) => (
                <li key={d} className="flex items-start gap-2 text-white/80 text-sm">
                  <Check size={15} className="text-crystal-orange mt-0.5 shrink-0" />
                  <span>{d}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="app-card p-6 flex flex-col justify-center items-start">
            <p className="text-white/70 text-sm mb-4">Available now on iPhone, iPad and Android.</p>
            <div className="flex flex-wrap gap-3">
              <a href={APP_STORE_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-base font-semibold cta-primary">
                <Apple size={18} /> App Store
              </a>
              <a href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full px-7 py-3.5 text-base font-semibold cta-primary">
                <Play size={18} /> Google Play
              </a>
            </div>
            <Link to="/auth?mode=signup" className="text-crystal-orange hover:underline text-sm mt-5">New here? Start your 7-day trial</Link>
          </div>
        </div>
      </section>
    </PublicPage>
  );
}
